import React from 'react';
import { Link } from "react-router-dom";
import { AbandonIcon } from '../../../utils/svg';

function NoOrders() {
  return (
    <div className="w-full h-[60vh] flex flex-col justify-center items-center px-4">
      <AbandonIcon className="fill-[var(--rose-violet)] w-40 h-auto" />
      <h2 className="text-base font-semibold">Isi keranjangmu dengan makanan lezat</h2>
      <p className="text-xs font-normal">Kamu belum memilih apa pun untuk dipesan.</p>
      <p className="text-xs font-normal">Yuk, cari yang kamu suka!</p>
      <Link to="/" className="w-full mt-8" id="order_history_explore_ufood">
        <button className="button w-full !bg-[var(--rose-violet)] !border-[var(--rose-violet)]">
          Jelajahi UFood
        </button>
      </Link>
    </div>
  );
}

export default NoOrders;
